/** Blocs « texte » issus de modèles (sections lo-section, témoignages, pricing…). */
export function isLoSiteStructuredTextBody(body: string): boolean {
  const html = body.trim();
  if (!html) return false;
  return html.includes('lo-section')
    || html.includes('lo-cta-final')
    || html.includes('lo-pain')
    || html.includes('lo-testimonials')
    || html.includes('lo-pricing')
    || html.includes('lo-steps')
    || html.includes('lo-faq');
}

/** Sélecteurs de texte modifiables sans altérer la structure HTML du module. */
export const LO_SITE_STRUCTURED_TEXT_EDITABLE_SELECTORS = [
  '.lo-section-head .lo-kicker',
  '.lo-section-head .lo-h2',
  '.lo-section-head .lo-lead',
  '.lo-testimonial blockquote',
  '.lo-testimonial cite',
  '.lo-testimonial cite span',
  '.lo-feature h3',
  '.lo-feature p',
  '.lo-step h3',
  '.lo-step p',
  '.lo-pain-item p',
  '.lo-pain-solution p',
  '.lo-faq-item summary',
  '.lo-faq-item p',
  '.lo-price-card h3',
  '.lo-price-card .price',
  '.lo-price-card .period',
  '.lo-price-card p',
  '.lo-pricing-note',
  '.lo-hero-v2-stats dt',
  '.lo-hero-v2-stats dd',
  '.lo-section > .lo-wrap > .lo-lead',
  '.lo-section > .lo-wrap > h2',
  '.lo-section > .lo-wrap > p',
  '.lo-cta-final h2',
  '.lo-cta-final p',
  '.lo-a11y-list li',
].join(', ');
